
export const SET_SEARCH_FILTERS="SET_SEARCH_FILTERS"
export const GET_COMPANY_DATA = 'GET_COMPANY_DATA';
export const GET_ALL_DEPARTMENTS = 'GET_ALL_DEPARTMENTS';
export const GET_ALL_EMPLOYEES = 'GET_ALL_EMPLOYEES';
export const GET_ALL_REGIONS = 'GET_ALL_REGIONS';
export const GET_ALL_STATUSES = 'GET_ALL_STATUSES';
